import { BlockStack, Box, Button, InlineStack, Popover, Scrollable, Thumbnail } from '@shopify/polaris';
import { useState } from 'react';
import { PopOverWrap, TitleWrapper } from './styled';
import BoldSmallText from '../BoldSmallText';
import { ImageIcon } from '@shopify/polaris-icons';
import { TextProps } from '@shopify/polaris';
import RegularText from '../RegularText';

type Variant = TextProps['variant'];

const PopoverItems = ({
  title,
  items,
  variant,
  titleWidth,
}: {
  title: string;
  items?: { title: string; imgSrc: string; quantity?: number }[];
  variant?: Variant;
  titleWidth?: string;
}) => {
  const [active, setActive] = useState(false);

  const activator = (
    <Button variant="monochromePlain" onClick={() => setActive(!active)} disclosure>
      {(<BoldSmallText variant={variant}>{title}</BoldSmallText>) as unknown as string}
    </Button>
  );
  return (
    <PopOverWrap
      onClick={(e) => {
        e.stopPropagation();
        document.body.click();
      }}
    >
      <Popover active={active} activator={activator} onClose={() => setActive(!active)}>
        <Box padding={'300'}>
          <Scrollable style={{ maxHeight: '200px' }} focusable scrollbarGutter="stable" scrollbarWidth="thin">
            <BlockStack gap={'100'}>
              {items?.map((item, index) => (
                <InlineStack key={'popover_product_' + index} blockAlign="center" align="space-between">
                  <InlineStack wrap={false} blockAlign="center" gap={'400'} align="end">
                    <Thumbnail size="small" source={item?.imgSrc || ImageIcon} alt="" />
                    <TitleWrapper width={titleWidth}>{item?.title}</TitleWrapper>
                  </InlineStack>
                  {item.quantity && <RegularText>{`x ${item.quantity}`}</RegularText>}
                </InlineStack>
              ))}
            </BlockStack>
          </Scrollable>
        </Box>
      </Popover>
    </PopOverWrap>
  );
};

export default PopoverItems;
